module.exports = (__webpack_require__(6))(416);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/isomorphic-fetch/fetch-npm-browserify.js from dll-reference vendor_aa0bb54e7e791c5951ff
// module id = 477
// module chunks = 6